import { Autocomplete, type AutocompleteProps, TextField } from "@mui/material";

import { useFieldContext } from "components/Forms/AppForm";

type SelectFieldProps = Omit<
  AutocompleteProps<string, false, false, false>,
  "renderInput"
> & {
  options: string[];
  label: string;
};

const AutocompleteSelect = ({
  options = [],
  label,
  ...props
}: SelectFieldProps) => {
  const field = useFieldContext<string>();

  return (
    <Autocomplete
      disablePortal
      size="small"
      options={options}
      renderInput={(params) => <TextField {...params} label={label} />}
      value={field.state.value}
      onChange={(e, value) => field.handleChange(value ?? "")}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      // These two props make groups based on the first letter of the option
      groupBy={(option) => option[0].toUpperCase()}
      getOptionLabel={(option) => option}
      {...props}
    />
  );
};
export default AutocompleteSelect;
